import { HeaderText } from '../../../../atoms/Texts/HeaderText';
import React, { useState } from 'react';
import { Switch } from '../../../../atoms/Buttons/Switchs/Switch';
import { useDispatch } from 'react-redux';
import { updateNgoContribution } from '../../../../../store/actions/panier.actions';
import usePublicShop from '../../../../../hooks/usePublicShop';
import emoji from '../../../../../theme/emoji';
import { Modal } from 'components/organisms/Modals/Modal';
import NgoModalPublicShop from './NgoModalPublicShop/NgoModalPublicShop';

interface NgoFieldProps {
  onChange?: (customerContributedToTheNgo: boolean) => void;
  defaultValue?: boolean;
}
export const NgoField = ({ onChange, defaultValue = false }: NgoFieldProps) => {
  const dispatch = useDispatch();
  const { isPublicShop } = usePublicShop();
  const handleChange = (doesClientContributeToNgo: boolean) => {
    if (onChange) {
      onChange(doesClientContributeToNgo);
    } else {
      dispatch(updateNgoContribution(doesClientContributeToNgo));
    }
  };
  const [modalStatus, setModalStatus] = useState(false);
  return (
    <>
      <HeaderText text="Contribution Ong" emoji={emoji['PalmsUpTogether']} />
      {isPublicShop && (
        <>
          <p>
            Souhaitez-vous faire un don de 1€ pour l'ONG de l'élève ?
            <span
              onClick={() => setModalStatus(true)}
              style={{ fontWeight: 600, cursor: 'pointer' }}
            >
              {' '}
              En savoir plus
            </span>
          </p>
          {modalStatus && (
            <Modal
              onCloseAction={() => setModalStatus(false)}
              isShowingDefault={true}
              modalHead={'Contribution ONG'}
            >
              <NgoModalPublicShop />
            </Modal>
          )}
        </>
      )}
      {!isPublicShop && (
        <p>
          Est-ce que votre client souhaite verser 1€ au profit de l'ONG que vous
          soutenez ?
        </p>
      )}

      <Switch
        onClick={value => handleChange(value)}
        defaultValue={defaultValue}
      />
    </>
  );
};
